
export let _import = (module)=>()=>import(`@/views${module}`)